"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var index_1 = __importDefault(require("../Button/index"));
var index_2 = require("../Icon/index");
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.onCrossClick = function (event) {
            event.preventDefault();
            _this.closeModal();
        };
        _this.closeModal = function () {
            if (!_this.state.open) {
                return;
            }
            _this.setState({
                open: false,
            });
            Modal.removeBodyState();
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.keyHandler = function (event) {
            if (event.keyCode === Modal.ESCAPE_KEY && _this.props.escapeToClose === true) {
                _this.closeModal();
            }
        };
        _this.state = {
            open: props.open,
        };
        if (props.open) {
            Modal.addBodyState();
        }
        return _this;
    }
    Modal.addBodyState = function () {
        document.body.classList.add("emankit__modal_open");
    };
    Modal.removeBodyState = function () {
        document.body.classList.remove("emankit__modal_open");
    };
    Modal.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.open !== prevState.open) {
            return {
                open: nextProps.open,
            };
        }
        return null;
    };
    Modal.prototype.componentDidMount = function () {
        window.addEventListener("keyup", this.keyHandler);
    };
    Modal.prototype.componentWillUnmount = function () {
        window.removeEventListener("keyup", this.keyHandler);
        Modal.removeBodyState();
    };
    Modal.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (prevState.open === false && this.state.open === true) {
            Modal.addBodyState();
        }
        if (prevState.open === true && this.state.open === false) {
            Modal.removeBodyState();
        }
    };
    Modal.prototype.render = function () {
        var _a = this.props, allowToClose = _a.allowToClose, buttons = _a.buttons, header = _a.header, children = _a.children, className = _a.className, escapeToClose = _a.escapeToClose, style = _a.style, rest = __rest(_a, ["allowToClose", "buttons", "header", "children", "className", "escapeToClose", "style"]);
        var open = this.state.open;
        var defaultStyle = __assign({}, style);
        if (!defaultStyle.width) {
            defaultStyle.maxWidth = "500px";
        }
        var closeButton = null;
        if (allowToClose) {
            closeButton = (react_1.default.createElement("div", { className: "close_button" },
                react_1.default.createElement(index_1.default, { onClick: this.onCrossClick, icon: index_2.IconType.Cross, className: "big" })));
        }
        var headerDiv;
        if (header || closeButton) {
            headerDiv = (react_1.default.createElement("div", { className: "emankit__modal__header" },
                header,
                closeButton));
        }
        return (react_1.default.createElement("div", { className: open ? undefined : "hide" },
            react_1.default.createElement("div", { className: "emankit__overlay" },
                react_1.default.createElement("div", __assign({ className: classnames_1.default("emankit__modal", className), style: defaultStyle }, rest),
                    react_1.default.createElement("div", { className: "emankit__modal__container" },
                        headerDiv,
                        react_1.default.createElement("div", { className: "emankit__modal__body" }, children),
                        react_1.default.createElement("div", { className: "emankit__modal__footer" }, buttons && buttons(this.state)))))));
    };
    Modal.defaultProps = {
        allowToClose: true,
        escapeToClose: true,
    };
    Modal.ESCAPE_KEY = 27;
    return Modal;
}(react_1.PureComponent));
exports.default = Modal;
//# sourceMappingURL=index.js.map